module.exports = __webpack_public_path__ + "img/pick4.d590c00e.png";